// =============================================================
// 📌 LiveStatsBar.jsx — Estatísticas ao vivo
// =============================================================

import React from "react";
import useRealtimeStats from "../../../hooks/iaDashboard/useRealtimeStats";

export default function LiveStatsBar() {
  const {
    activeCount,
    pendingCount,
    typingCount,
    operatorControlled,
    aiControlled,
  } = useRealtimeStats();

  return (
    <div className="ia-realtime-box">
      <h3 className="ia-dashboard-panel-title">📡 Estatísticas ao vivo</h3>

      <div className="ia-realtime-item">
        <strong>Ativos:</strong> {activeCount}
      </div>

      <div className="ia-realtime-item">
        <strong>Pendentes:</strong> {pendingCount}
      </div>

      <div className="ia-realtime-item">
        <strong>Digitando agora:</strong> {typingCount}
      </div>

      <div className="ia-realtime-item">
        <strong>Controle do operador:</strong> {operatorControlled}
      </div>

      <div className="ia-realtime-item">
        <strong>Controle da IA:</strong> {aiControlled}
      </div>
    </div>
  );
}
